import {
  FilterCondition,
  FilterOperator,
  PagedResultDTOOfParkerRegistrationWithParkerInfoDTO,
  ParkerRegistrationOffense,
  ParkerRegistrationType,
} from '../../base/models/models.swagger.generated';
import { ClientService } from '../../base/services/client/client.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FilterDTO, ParkerRegistrationClient, SortDirection } from 'src/app/base/models/models.swagger.generated';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { ParkerOffenseFilterType } from 'src/app/base/models/parker-offense-filter-type.enum';
import { FilterUtil } from 'src/app/base/shared/filter-util';
import { DATE_HELPER_DEFAULT_TIME_ZONE } from 'src/app/base/shared/date-helper';

export const controlPlateField = 'ControlPlate';
export const countryCodeField = 'CountryCode';
export const zoneNameField = 'RegisteredZoneName';
export const zoneDeviceNameField = 'RegisteredByZoneDeviceName';

@Injectable()
export class ParkerRegistrationService extends ShowInactiveService implements IAdaptorService {

  public offenseType: ParkerOffenseFilterType;

  constructor(private parkerRegistrationClient: ParkerRegistrationClient,
              private clientService: ClientService) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection):
          Observable<PagedResultDTOOfParkerRegistrationWithParkerInfoDTO> {
    if (!sortBy) {
      sortBy = 'RegistrationDateTime';
      sortDirection = SortDirection.Descending;
    } else if (sortBy === zoneDeviceNameField) {
      sortBy = 'RegisteredByZoneDevice.Name';
    } else if (sortBy === zoneNameField) {
      sortBy = 'RegisteredZone.Name';
    }

    this.adjustControlPlateFilters(filters);
    this.adjustCountryCodeFilters(filters);
    this.adjustZoneNameFilters(filters);
    this.adjustZoneDeviceNameFilters(filters);
    if (!this.showInactive) {
      if (!filters) {
        filters = [];
      }
      filters.push(new FilterDTO({isComplex: false, field: 'Active', operator: FilterOperator.Equal, value: 'true'}));
    }
    FilterUtil.correctDateTimeFilters(filters, 'RegistrationDateTime', DATE_HELPER_DEFAULT_TIME_ZONE);
    this.addFiltersByOffenseType(filters);

    return this.parkerRegistrationClient.searchRegistrations(this.clientService.selectedClient?.id, filters, skip, take, sortBy, sortDirection);
  }

  public addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  private addFiltersByOffenseType(filters: FilterDTO[]): void {
    if (!filters.length) {
      filters = [];
    }

    if (this.offenseType === ParkerOffenseFilterType.Parker) {
      filters.push(new FilterDTO({
        isComplex: false,
        field: 'Offense',
        operator: FilterOperator.NotEqual,
        value: ParkerRegistrationOffense.NoOffense.toString()
      }));
    } else if (this.offenseType === ParkerOffenseFilterType.Offense) {
      filters.push(new FilterDTO({
        isComplex: false,
        field: 'PenaltyIssued',
        operator: FilterOperator.Equal,
        value: 'true'}));
    } else if (this.offenseType === ParkerOffenseFilterType.ParkingRangerEntry) {
      filters.push(new FilterDTO({
        isComplex: false,
        field: 'Type',
        operator: FilterOperator.Equal,
        value: ParkerRegistrationType.ParkingRangerEntry.toString()
      }));
    }
  }

  private adjustControlPlateFilters(filters: FilterDTO[]): void {
    if (!filters) {
      filters = [];
    }

    const registeredByFilters = filters.filter(f => f.field === controlPlateField);
    if (registeredByFilters.length) {
      this.adjustControlPlateFilter(registeredByFilters[0]);
    }
  }

  private adjustControlPlateFilter(registeredByFilter: FilterDTO): void {
    if (!registeredByFilter) {
      return;
    }
    // ajdust filter
    registeredByFilter.isComplex = true;
    registeredByFilter.condition = FilterCondition.Or;
    registeredByFilter.predicates = [
      new FilterDTO({
        isComplex: false,
        field: 'KnownTag.ControlPlateNumber',
        operator: registeredByFilter.operator,
        value: registeredByFilter.value
      }),
      new FilterDTO({
        isComplex: false,
        field: 'UnknownParkerTagControlPlateNumber',
        operator: registeredByFilter.operator,
        value: registeredByFilter.value
      }),
    ];
    registeredByFilter.operator = undefined;
    registeredByFilter.value = undefined;
  }

  private adjustCountryCodeFilters(filters: FilterDTO[]): void {
    if (!filters) {
      filters = [];
    }

    const countryCodeFilters = filters.filter(f => f.field === countryCodeField);
    if (countryCodeFilters.length) {
      this.adjustCountryCodeFilter(countryCodeFilters[0]);
    }
  }

  private adjustCountryCodeFilter(countryCodeFilter: FilterDTO): void {
    if (!countryCodeFilter) {
      return;
    }
    // adjust filter
    countryCodeFilter.isComplex = true;
    countryCodeFilter.condition = FilterCondition.Or;
    countryCodeFilter.predicates = [
      new FilterDTO({
        isComplex: false,
        field: 'KnownTag.CountryCode',
        operator: countryCodeFilter.operator,
        value: countryCodeFilter.value
      }),
      new FilterDTO({
        isComplex: false,
        field: 'UnknownParkerTagCountryCode',
        operator: countryCodeFilter.operator,
        value: countryCodeFilter.value
      }),
    ];
    countryCodeFilter.operator = undefined;
    countryCodeFilter.value = undefined;
  }

  private adjustZoneNameFilters(filters: FilterDTO[]): void {
    FilterUtil.replaceFieldNameInfilters(filters, zoneNameField, 'RegisteredZone.Name');
  }

  private adjustZoneDeviceNameFilters(filters: FilterDTO[]): void {
    FilterUtil.replaceFieldNameInfilters(filters, zoneDeviceNameField, 'RegisteredByZoneDevice.Name');
  }
}
